






















































import {Component, Prop, Vue} from 'vue-property-decorator'
import OrderItemCard from "./OrderItemCard.vue";
import TimezoneTooltip from "@/components/TimezoneTooltip.vue";
import {
  IContactWay,
  ICustomerData,
  IDate,
  IDateRange,
  IModalInitData,
  IRequestService,
  IRequestServiceHistory,
  RequestServiceStatus
} from '@/entities'
import {StatusTagType} from '@/components/lib/models'
import {rangeLabel} from "@/lib";

@Component({
  components: {
    OrderItemCard,
    TimezoneTooltip
  }
})
export default class OrderServiceItemCard extends Vue {

  @Prop() readonly data!: IRequestService
  @Prop({ default: false }) readonly showControl?: boolean
  @Prop() readonly customer?: ICustomerData
  @Prop() readonly token?: string

  get haveBody(): boolean {
    let emptyStatuses: RequestServiceStatus[] = [
      'new',
      'ready'
    ];
    return (emptyStatuses.indexOf(this.data.status) === -1) && !!this.data.contact;
  }

  get contactValue(): string {
    let contact = this.data.contact;
    let ways = contact?.contact_way?.map(
      (way: IContactWay) => way.name.toLowerCase()
    );
    let hasEmail = ways?.indexOf('email') !== -1;
    let hasEmailOnly = hasEmail && (ways?.length === 1);
    let email = this.customer?.email;
    let value = contact?.value;
    let res = hasEmail ? (email + (hasEmailOnly ? '' : (', ' + value))) : value;
    return res ? (res + '.') : '';
  }

  get eventDate(): string {
    return this.getAsLocalDate(this.data.date_event);
  }

  get serviceDates(): IDateRange | undefined {
    const start = this.data.date_service_from;
    const end = this.data.date_service_to;
    return (start || end) ? {
      start,
      end
    } : undefined;
  }

  get serviceDatesString(): string {
    const dates = this.serviceDates;
    return rangeLabel(dates?.start?.toString(), dates?.end?.toString(), (value: any) => {
      return this.getAsLocalDate(value, true);
    }, {
      between: ' - ',
      minus: this.$options.filters?.capitalize(this.$t('lim-to')) + ' '
    });
  }

  private getAsLocalDate(date?: IDate, noTime?: boolean): string {
    // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    // hours: -date.getTimezoneOffset() / 60
    return date ? this.$storage.getters.getLocaleDate(date, noTime) : '';
  }

  get scope(): string {
    return 'statuses.entities.' + this.data.type;
  }

  get modalData(): IModalInitData {
    return {
      name: 'ModalConsultation',
      subject: this.data,
      from: 'order',
      key: this.token
    }
  }

  private openQuiz(): void {
    this.$storage.actions.setModal({
      ...this.modalData,
      step: 'message'
    });
  }

  private setContact(): void {
    this.$storage.actions.setModal({
      ...this.modalData,
      step: 'check'
    });
  }

  private editContact(): void {
    this.$storage.actions.setModal({
      name: 'ModalOrderItemContact',
      subject: this.data,
      from: 'order',
      key: this.token
    });
  }

  private resetUnlimitedService(): void {
    this.$storage.actions.appendService({
      key: this.token,
      payload: {
        request_service: this.data.id
      }
    })
      .then(res => {
        this.$emit('append-service', res);
      });
  }

  private mapStatus(status?: string): StatusTagType {
    switch (status) {
      case "done":
        return 'success'
      case "active":
      case "appointed":
      case "ready":
        return 'progress'
      case "new":
        return 'none'
      default:
        return 'warning'
    }
  }

  private fetchHistories(): Promise<IRequestServiceHistory[]> {
    return this.$storage.actions.getRequestServiceHistories({
      key: this.data.id
    });
  }

}
